import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dynamicLink',
})
export class DynamicLinkPipe implements PipeTransform {
  transform(value: string, links: string[]): unknown {
    for (const link of links) {
      const startTag = `<a href='${link}' target='_blank'>`;
      const closeTag = `</a>`;
      value = value.replace('{{', startTag).replace('}}', closeTag);
    }
    return value;
  }
}
